import Head from 'next/head';
import Link from 'next/link';

import { AboutGLFHHelpSEO } from '@/utils/constants/MetaData';

const AboutGoldLoanFromHome = () => {
  return (
    <>
      <Head>
        <title>{AboutGLFHHelpSEO.metaTitle}</title>
        <meta name="description" content={AboutGLFHHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={AboutGLFHHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/gold-loans/about-gold-loan-from-home/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Gold Loan Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                About Gold Loan from Home
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              About Gold Loan from Home
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is a Gold Loan from Home?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    A Gold Loan from Home is a service where you can get a Gold
                    Loan at your home, unlike the traditional Gold Loan where
                    you visit a Bank or an NBFC. We process your Gold Loan at
                    your home seamlessly. Our loan managers will carry your gold
                    jewellery safely to a nearby Muthoot FinCorp branch, so you
                    don’t have to worry about traveling with your gold
                    jewellery.
                    <br />
                    **Available in selected cities
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What are the benefits of getting a Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    When you book an appointment for a Gold Loan from Home, we
                    come to your home to collect the gold jewellery at your
                    preferred date and time, making the process easy,
                    hassle-free, and seamless. Additionally, we carry your
                    pledged gold jewellery to a nearby Muthoot FinCorp branch in
                    a GPS-tracked safe locker, so you don&apos;t have to carry
                    it yourself. Your pledged gold jewellery is automatically
                    insured as an added layer of protection.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  How is a Gold Loan from Home different from a traditional Gold
                  Loan?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    A Gold Loan from Home is a service where you can get a Gold
                    Loan at your home, unlike the traditional Gold Loan where
                    you visit a Bank or an NBFC. We process your Gold Loan at
                    your home seamlessly and our loan managers carry your gold
                    jewellery safely to a nearby Muthoot FinCorp branch, so you
                    don&apos;t have to worry about traveling with your gold
                    jewellery.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What are the different Gold Loan schemes available for Gold
                  Loan from Home?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    We offer various schemes on our Gold Loan from Home that you
                    can get through our app. To check the details of the
                    different schemes available please visit the Gold Loan page
                    on the app.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  What is the tenure for repayment of a Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can choose the tenure of your liking depending on your
                    loan amount and the various Gold Loan schemes available when
                    you get our Gold Loan from Home. Please go through the
                    different schemes in detail before selecting the tenure and
                    scheme.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What is a holiday period in a Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    A holiday period is a period in a loan during which the
                    interest slab remains the same. You can ask about the
                    holiday period in your selected scheme from our Loan
                    Manager, once you make an appointment with us for a Gold
                    Loan from Home.
                  </p>
                </div>
              </div>
            </div> */}
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  Can I make changes to the existing Gold Loan from Home schemes
                  available?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    All our schemes have been designed keeping the best interest
                    of our customers in mind and you can pick the scheme of your
                    liking basis the loan amount, rate of interest, and other
                    parameters that work best for you. To check the details of
                    the schemes available please visit the Gold Loan page on the
                    app.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  In which cities is Gold Loan from Home available?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Currently we offer a Gold Loan from Home in Agra, Amritsar,
                    Ahmedabad, Bangalore, Baroda, Bhopal, Bhubaneswar,
                    Chandigarh, Chennai, Cochin, Coimbatore, Cuttack, Delhi-NCR,
                    Hyderabad, Indore, Jaipur, Kanpur, Kolkata, Kota, Lucknow,
                    Ludhiana, Madurai, Mumbai, Nagpur, Pune, Surat, Trivandrum,
                    Vijayawada and Visakhapatnam. Gold Loan from Home is coming
                    soon to more cities in India.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingNine"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  What is Loan-to-Value (LTV) rate for Gold Loans and how does
                  it impact my loan amount?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingNine"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The LTV (Loan-to-Value) rate determines your maximum Gold
                    Loan amount eligibility for the appraised value of your gold
                    jewellery. Since gold prices fluctuate daily, it directly
                    impacts your maximum loan eligibility. Additionally, the
                    scheme you select also determines the final Gold Loan
                    amount. For more details please check the Muthoot FinCorp
                    ONE app to understand your borrowing capacity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AboutGoldLoanFromHome;
